export default class TripView {
  constructor() {
    $("#trip").on("click", "a#change_status", function(e) {
      const result = confirm(
        "You are about to change the status of a trip. " +
        "This change might be visible to the customer. " +
        "This should only be done if a mistake has been " +
        "made when setting the current status for this " +
        "trip. Are you sure you want to change this status?"
      )

      if (result) {
        $('#status_read').addClass('d-none');
        $('#status_write').removeClass('d-none');
      }

      e.preventDefault()
    })
  }
}
